module.exports = __webpack_public_path__ + "static/media/xml-icon.8f0895b3.svg";